<div
  class="panel carouselMode"
  [class.flipMode]="!chapter._enabled"
  *ngIf="mode === 'carousel'"
>
  <div
    class="panel-body"
    [style]="{
      background: chapter._enabled
        ? 'transparent linear-gradient(140deg, ' +
          chapter.background_color +
          ' 0%, ' +
          chapter.gradient_color +
          ' 100%) 0% 0%'
        : '#a2a2a2'
    }"
  >
    <div
      class="panel-front"
      [ngStyle]="{ backgroundImage: 'url(' + chapter.image + ')' }"
    >
      <!-- HEAD -->
      <div class="header">
        <h2
          class="title"
          [style]="{ color: chapter._enabled ? chapter.font_color : '#fff' }"
        >
          {{ "shared-components.panel.chapter-label" | translate }}
          {{ chapterNumber + 1 }}
        </h2>
        <h3
          class="sub-title"
          [style]="{ color: chapter._enabled ? chapter.font_color : '#fff' }"
        >
          {{ chapter.name }}
        </h3>
      </div>
      <!-- PROGRESS PERCENT -->
      <a
        class="progress-wrapper"
        [routerLink]="
          chapter._enabled
            ? '/dashboard/student-questionary/' + questionaryId + '/chapters/' + chapter.id
            : null
        "
      >
        <circle-progress
          *ngIf="chapter._enabled; else locked"
          [outerStrokeGradient]="false"
          [outerStrokeColor]="chapter._enabled ? chapter.font_color : '#fff'"
          [percent]="chapter.progress.progress_percentage"
          [unitsColor]="chapter._enabled ? chapter.font_color : '#fff'"
          [titleColor]="chapter._enabled ? chapter.font_color : '#fff'"
          [options]="circleProgressOption"
        >
        </circle-progress>
        <ng-template #locked>
          <img
            class="locked-icon"
            src="/assets/images/icons/icon_locked.svg"
            alt=""
          />
        </ng-template>
      </a>
      <!-- THEME PROGRESS -->
      <p
        class="themes-progress"
        *ngIf="chapter._enabled"
        [style]="{ color: chapter._enabled ? chapter.font_color : '#fff' }"
      >
        <span
          [style]="{ color: chapter._enabled ? chapter.font_color : '#fff' }"
          *ngIf="chapter.progress.children_completed_1"
          >{{ chapter.progress.children_completed_1 }}</span
        >
        <span
          [style]="{ color: chapter._enabled ? chapter.font_color : '#fff' }"
          *ngIf="!chapter.progress.children_completed_1"
          >0</span
        >/{{ chapter.progress.children_total_1 }}
        {{ "shared-components.panel.themes-label" | translate }}
      </p>
    </div>

    <!-- <div class="panel-back" *ngIf="!chapter._enabled" [ngStyle]="{backgroundImage: 'url('+chapter.image+')' }">
      <div class="header">
        <img src="/assets/images/icons/icon_locked.svg" class="icon" alt="">
        <h2 class="title" [style]="{color: chapter._enabled ? chapter.font_color : '#fff'}">Capítulo
          {{chapterNumber+1}}: {{chapter.name}}
        </h2>
      </div>
      <p class="description" [style]="{color: chapter._enabled ? chapter.font_color : '#fff'}">
        {{chapter.description}}
      </p>
      <button *ngIf="!userSubscribed" [routerLink]="'/dashboard/membership'"
        class="btn bg-green text-white font-primary--b">
        Desbloquear Capítulos
      </button>
    </div> -->
  </div>
</div>

<div *ngIf="mode === 'chapterList'">
  <div
    class="panel panel-chapter"
    [class.carousel-panel]="isCarousel"
    [style]="{
      background: chapter._enabled
        ? 'transparent linear-gradient(140deg, ' +
          chapter.background_color +
          ' 0%, ' +
          chapter.gradient_color +
          ' 100%) 0% 0%'
        : '#a2a2a2'
    }"
  >
    <div
      class="content-wrapper"
      [ngStyle]="{ backgroundImage: 'url(' + chapter.image + ')' }"
    >
      <div class="header">
        <h2
          class="title"
          [style]="{ color: chapter._enabled ? chapter.font_color : '#fff' }"
        >
          {{ "shared-components.panel.chapter-label" | translate }}
          {{ chapterNumber + 1 }}
        </h2>
        <h3
          class="sub-title"
          [style]="{ color: chapter._enabled ? chapter.font_color : '#fff' }"
        >
          {{ chapter.name }}
        </h3>
      </div>
      <a
        class="progress-wrapper"
        [routerLink]="
          chapter._enabled
            ? '/dashboard/student-questionary/' + questionaryId + '/chapters/' + chapter.id
            : null
        "
      >
        <circle-progress
          *ngIf="chapter._enabled; else locked"
          [outerStrokeGradient]="false"
          [outerStrokeColor]="chapter._enabled ? chapter.font_color : '#fff'"
          [percent]="chapter.progress.progress_percentage"
          [unitsColor]="chapter._enabled ? chapter.font_color : '#fff'"
          [titleColor]="chapter._enabled ? chapter.font_color : '#fff'"
          [options]="circleProgressOption"
        >
        </circle-progress>
        <ng-template #locked>
          <img
            class="locked-icon"
            src="/assets/images/icons/icon_locked.svg"
            alt=""
          />
        </ng-template>
      </a>
      <p
        class="themes-progress"
        *ngIf="chapter._enabled"
        [style]="{ color: chapter._enabled ? chapter.font_color : '#fff' }"
      >
        <span
          [style]="{ color: chapter._enabled ? chapter.font_color : '#fff' }"
          *ngIf="chapter.progress.children_completed_1"
          >{{ chapter.progress.children_completed_1 }}</span
        >
        <span
          [style]="{ color: chapter._enabled ? chapter.font_color : '#fff' }"
          *ngIf="!chapter.progress.children_completed_1"
          >0</span
        >/{{ chapter.progress.children_total_1 }}
        {{ "shared-components.panel.themes-label" | translate }}
      </p>
    </div>
  </div>
</div>

<div
  class="panel-wrapper"
  [ngClass]="{ 'opacity-50': !chapter.enabled }"
  *ngIf="mode === 'default'"
>
  <div class="panel-wrapper-container"
       [ngClass]="{ 'panel-wrapper-container-completed': isChapterCompleted(chapter),
       'panel-wrapper-container-not-enabled': !chapter.enabled }" >
    <div class="panel-wrapper-container-img">
      <img [ngSrc]="chapter.image" alt="Image" width="154" height="130">
    </div>
    <div class="panel-wrapper-container-right">
      <h2 class="font-primary--b">
        {{ chapter.name }}
      </h2>
      <p [innerHtml]="chapter.description ?? '' | safeHtml"></p>

      <div class="panel-wrapper-container-right-actions">
         <img class="completed-icon" alt="Icon edit" height="24" width="24"
              [ngClass]="{ 'disabled': !chapter.enabled }"
              [routerLink]="
              '/dashboard/student-questionary/' + questionaryId + '/chapters/' + chapter.id"
            *ngIf="chapter.enabled" ngSrc="/assets/images/icons/icon-pencil.svg"/>
        <img class="completed-icon" alt="Icon check circle" height="24" width="24"
             *ngIf="isChapterCompleted(chapter)" ngSrc="/assets/images/icons/icon-check-circle.svg"/>
        <img class="completed-icon" alt="Icon red circle" height="24" width="24"
             *ngIf="!isChapterCompleted(chapter)" ngSrc="/assets/images/icons/icon-red-circle.svg"/>
      </div>
    </div>
  </div>
<!--  <div class="panel-body panel-body&#45;&#45;alter">-->
<!--    <div class="panel-front">-->
<!--&lt;!&ndash;      <div&ndash;&gt;-->
<!--&lt;!&ndash;        class="header"&ndash;&gt;-->
<!--&lt;!&ndash;        [class.completed]="isChapterCompleted(chapter)"&ndash;&gt;-->
<!--&lt;!&ndash;        [ngStyle]="dynamicStyles(chapter)"&ndash;&gt;-->
<!--&lt;!&ndash;      ></div>&ndash;&gt;-->
<!--      <div class="content">-->
<!--        <img [ngSrc]="chapter.image" alt="Image" width="154" height="130">-->

<!--        <h2 class="main-title font-18">-->
<!--          {{ chapter.name }}-->
<!--        </h2>-->
<!--        <div class="description font-14">-->
<!--          <div [innerHtml]="chapter.description | safeHtml"></div>-->
<!--        </div>-->
<!--        <div class="footer">-->
<!--          <div class="time-wrapper">-->
<!--            <img-->
<!--              class="icon-time"-->
<!--              src="/assets/images/icons/icon_time.svg"-->
<!--              alt=""-->
<!--            />-->
<!--            <span class="value-time">{{ chapter.time }} min.</span>-->
<!--          </div>-->
<!--          <button-->
<!--            [disabled]="!chapter.enabled"-->
<!--            [routerLink]="-->
<!--              '/dashboard/seasons/' + questionaryId + '/chapters/' + chapter.id-->
<!--            "-->
<!--            class="btn bg-transparent text-sky-blue font-primary&#45;&#45;b"-->
<!--          >-->
<!--            {{ "shared-components.panel.enter-button" | translate }}-->
<!--          </button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    &lt;!&ndash; <div class="panel-back" *ngIf="!chapter._enabled" [ngStyle]="{backgroundImage: 'url('+chapter.image+')' }">-->
<!--      <div class="header">-->
<!--        <img src="/assets/images/icons/icon_locked.svg" class="icon" alt="">-->
<!--        <h2 class="title" [style]="{color: chapter._enabled ? chapter.font_color : '#fff'}">Capítulo-->
<!--          {{chapterNumber+1}}: {{chapter.name}}-->
<!--        </h2>-->
<!--      </div>-->
<!--      <p class="description" [style]="{color: chapter._enabled ? chapter.font_color : '#fff'}">-->
<!--        {{chapter.description}}-->
<!--      </p>-->
<!--      <button *ngIf="!userSubscribed" [routerLink]="'/dashboard/membership'"-->
<!--        class="btn bg-green text-white font-primary&#45;&#45;b">-->
<!--        Desbloquear Capítulos-->
<!--      </button>-->
<!--    </div> &ndash;&gt;-->
<!--  </div>-->
</div>
